import React, { useState, useEffect } from "react";
import BulkDevicesView from "../BulkDevices";
import StatusDevice from "./StatusDevice";
import { Tab } from '@hydrodigital/design-system';

const DevicesView: React.FC = () => {
  // ... existing code ...
  return (
    <div>
      <div className="text-title-page">Devices</div>
      <Tab
        tabs={[
          {
            id: 'UPLOAD',
            label: 'UPLOAD DEVICE',
            content: <BulkDevicesView />,
          },
          {
            id: 'STATUS',
            label: 'STATUS DEVICE',
            content: <StatusDevice />,
          },
        ]}
        showContent
        orientation="horizontal"
      />
    </div>
  );
  // ... existing code ...
};

export default DevicesView;